var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        "min-width": "700px",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading,
                    disabled: _vm.loading || !_vm.canCreate
                  },
                  on: { click: _vm.create }
                },
                [_vm._v(" Iniciar Conversa ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [_vm._v("Nova Conversa")])
        ]),
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "pa-4" }, [
            _c(
              "div",
              { staticClass: "contact-search-block pa-4 rounded-md" },
              [
                _vm.showConexaoSelector
                  ? _c("input-by-type", {
                      staticClass: "align-icon-search mb-4",
                      attrs: {
                        type: "autocomplete",
                        options: _vm.conexaoOptions,
                        labelExternal: "Conexão*",
                        placeholder: "Selecione uma conexão...",
                        dense: "",
                        "hide-details": "",
                        "data-test": "conexao-select"
                      },
                      model: {
                        value: _vm.selectedConexao,
                        callback: function($$v) {
                          _vm.selectedConexao = $$v
                        },
                        expression: "selectedConexao"
                      }
                    })
                  : _vm._e(),
                _vm.loadingSync
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-center align-center" },
                      [
                        _c("v-progress-circular", {
                          staticClass: "mr-2",
                          attrs: {
                            indeterminate: "",
                            size: "16",
                            width: "2",
                            color: "primary"
                          }
                        }),
                        _c("span", { staticClass: "az-text-small" }, [
                          _vm._v(" Sincronizando contatos do WhatsApp.. ")
                        ])
                      ],
                      1
                    )
                  : _vm.syncDone
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-center align-center" },
                      [
                        _c("icon-svg", {
                          staticClass: "mr-1",
                          attrs: {
                            name: _vm.icons.checkCircle,
                            size: "16",
                            color: "success"
                          }
                        }),
                        _c("span", { staticClass: "az-text-small" }, [
                          _vm._v("Contatos sincronizados")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm.selectedConexao
              ? _c(
                  "div",
                  {
                    staticClass:
                      "az-card-no-shadow no-padding no-border mt-4 pa-4 pt-0"
                  },
                  [
                    _c(
                      "v-radio-group",
                      {
                        staticClass: "mt-0 pt-0 modo-origem-radio-group",
                        attrs: {
                          row: "",
                          dense: "",
                          "hide-details": "",
                          "data-test": "modo-origem-radio"
                        },
                        model: {
                          value: _vm.modoOrigem,
                          callback: function($$v) {
                            _vm.modoOrigem = $$v
                          },
                          expression: "modoOrigem"
                        }
                      },
                      _vm._l(_vm.modoOrigemOptions, function(opt) {
                        return _c("v-radio", {
                          key: opt.value,
                          attrs: {
                            label: opt.label,
                            value: opt.value,
                            "data-test": "modo-origem-" + opt.value
                          }
                        })
                      }),
                      1
                    ),
                    _vm.modoOrigem === "contato"
                      ? _c(
                          "div",
                          { staticClass: "modo-origem-content" },
                          [
                            _c("SearchContactList", {
                              attrs: {
                                items: _vm.searchResults,
                                selected: _vm.selectedContato,
                                loading: _vm.loadingSearch,
                                label: "Buscar contato",
                                placeholder:
                                  "Nome ou telefone (mínimo 2 caracteres)",
                                "data-test": "search-contato"
                              },
                              on: {
                                search: _vm.onSearchInput,
                                select: _vm.selectContato,
                                clear: _vm.clearSelectedContato
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.modoOrigem === "manual"
                      ? _c(
                          "div",
                          { staticClass: "modo-origem-content" },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0",
                                attrs: { "no-gutters": "" }
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 pr-2",
                                    attrs: { cols: "7" }
                                  },
                                  [
                                    _c("input-by-type", {
                                      staticClass: "align-icon-search",
                                      staticStyle: { "min-width": "175px" },
                                      attrs: {
                                        labelExternal: "Telefone*",
                                        placeholder: "+5511999887766",
                                        dense: "",
                                        outlined: "",
                                        "hide-details": "",
                                        "data-test": "manual-telefone"
                                      },
                                      model: {
                                        value: _vm.manualTelefone,
                                        callback: function($$v) {
                                          _vm.manualTelefone = $$v
                                        },
                                        expression: "manualTelefone"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { staticClass: "pa-0", attrs: { cols: "5" } },
                                  [
                                    _c("input-by-type", {
                                      staticClass: "align-icon-search",
                                      staticStyle: { "min-width": "175px" },
                                      attrs: {
                                        labelExternal: "Nome",
                                        dense: "",
                                        outlined: "",
                                        "hide-details": "",
                                        placeholder: "João...",
                                        "data-test": "manual-nome"
                                      },
                                      model: {
                                        value: _vm.manualNome,
                                        callback: function($$v) {
                                          _vm.manualNome = $$v
                                        },
                                        expression: "manualNome"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 mt-2",
                                    attrs: { cols: "12" }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "az-text-small" },
                                      [_vm._v("* Campos obrigatórios")]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.modoOrigem === "cliente-base"
                      ? _c(
                          "div",
                          { staticClass: "modo-origem-content" },
                          [
                            _c("input-by-type", {
                              staticClass: "align-icon-search",
                              attrs: {
                                type: "autocomplete",
                                options: _vm.clientsOptions,
                                labelExternal: "Cliente*",
                                placeholder: "Selecione um cliente da base...",
                                loading: _vm.loadingClientes,
                                dense: "",
                                "hide-details": "",
                                "data-test": "cliente-base-select"
                              },
                              model: {
                                value: _vm.selectedClienteId,
                                callback: function($$v) {
                                  _vm.selectedClienteId = $$v
                                },
                                expression: "selectedClienteId"
                              }
                            }),
                            _vm.selectedCliente &&
                            !_vm._extractTelefone(_vm.selectedCliente)
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "az-text-small error--text mt-2",
                                    attrs: {
                                      "data-test":
                                        "cliente-base-sem-telefone-hint"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      ' Este cliente não possui telefone cadastrado. Selecione outro ou use "Inserir manualmente". '
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }